<template>
  <div class="hv-stepper"> 
    <div class="checkoutFakeHeader fixed-top">
      <div class="container-max">
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="brand-wrapper px-lg-3 d-flex flex-fill">
              <a class="navbar-brand py-2" href="/">
                <picture>
                  <source srcset="https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Logos/LOGO_1.png">
                  <img class="img-fluid" src="https://cdn02.plentymarkets.com/4tnz2nlw17zy/frontend/Logos/LOGO_1.png" alt="Hochwertige Kosmetikspiegel in echter Manufakturqualität auf kosmetikspiegel.shop"/>
                </picture>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="headerStepper">
              <ol class="step-wrapper d-flex flex-wrap">
                <li class="step-item" @click="changeStep(1)" :class="{ active: this.activeStep === 1, 'visited': this.activeStep > 1 }">
                  <slot name="title-one"></slot>
                </li>                
                <li class="step-item" @click="changeStep(2)" :class="{ active: this.activeStep === 2, 'visited': this.activeStep > 2, 'invalid': !this.isAddressValid }">
                  <slot name="title-two"></slot> 
                </li>            
                <template v-if="spcount > 1">
                  <li class="step-item" @click="changeStep(3)" :class="{ active: this.activeStep === 3, 'visited': this.activeStep > 3 }">
                    <slot name="title-three"></slot>
                  </li>
                </template>                
                <li class="step-item" @click="changeStep(4)" :class="{ active: this.activeStep === 4 }">
                  <slot name="title-four"></slot>
                </li>
              </ol>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="nextWrapper px-lg-3">
              <a class="next-step" v-if="activeStep == 1" :href="'/'+lang+'/checkout'" >
                <div class="t3">{{ $translate("CeresCoconut::Template.basketNextStepButton") }}<i class="pl-1 fa fa-chevron-right" aria-hidden="true"></i></div>
              </a>
              <a class="next-step" v-if="activeStep === 2 || activeStep === 3"  @click="nextStep()" >
                <div class="t3">{{ $translate("CeresCoconut::Template.basketNextStepButton") }}<i class="pl-1 fa fa-chevron-right" aria-hidden="true"></i></div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
		
		<div class="" :class="{'row': !isBasket }">
			<div :class="{'col-lg-7': !isBasket }">
				<div :class="{'row': isBasket }" v-show="activeStep === 1"><slot name="step-one"></slot></div>
				<div v-show="activeStep === 2"><slot name="step-two"></slot></div>
        <template v-if="spcount > 1">
          <div v-show="activeStep === 3"><slot name="step-three"></slot></div>
        </template>
				
				<div v-show="activeStep === 4"><slot name="step-four"></slot></div>
				<button class="btn btn-primary btn-large btn-appearance btn-next" v-if="activeStep === 2 || activeStep === 3" @click="nextStep()">           
           <template v-if="activeStep === 3 || activeStep === 2 && spcount === 1">
            {{ $translate("CeresCoconut::Template.checkoutNextBtnTextStep3") }}
          </template>
          <template v-else>
            {{ $translate("CeresCoconut::Template.checkoutNextBtnText") }}
          </template>
				</button>
			</div>
			<div class="col-lg-5" v-if="!isBasket">
				<slot name="step-right-side"></slot>
        <button class="btn btn-primary btn-large btn-appearance btn-next" v-if="activeStep === 2 || activeStep === 3" @click="nextStep()">
          <template v-if="activeStep === 3 || activeStep === 2 && spcount === 1">
            {{ $translate("CeresCoconut::Template.checkoutNextBtnTextStep3") }}
          </template>
          <template v-else>
            {{ $translate("CeresCoconut::Template.checkoutNextBtnText") }}
          </template>
				</button>
				<div v-show="activeStep === 4">
          <shipping-privacy-hint-check></shipping-privacy-hint-check>

	        <accept-gtc-check class="gtcCheck"></accept-gtc-check>
          <slot name="step-right-side-btn"></slot>
        </div>
        <div class="sslEncryption mt-3 text-success">
          <span class="h6"> 
            <i class="fa fa-lock mr-1" aria-hidden="true"></i>
            <b>
              {{ $translate("CeresCoconut::Template.checkoutSSLConnection") }}
            </b>
          </span>
        </div>
			</div>
		</div>
	</div>
</template>


<script>
export default {
    name: "heista-stepper",
    props:
    {
        initStep:
        {
          type: Number,
          default: 1
        },
        isBasket:
        {
            type: Boolean,
            default: false
        },
        spcount:
        {
            type: Number,
            default: 1
        },
        lang:
        {
          type: String,
          default: "de"
        }
    },
    data() {
      return {
        activeStep: this.initStep,
        isAddressValid: true
      }
    },
    computed: {
      ...Vuex.mapState({
            billingAddress: state => state.address.billingAddress
      })
    },
    watch: { 
        billingAddress(newVal, oldVal) { 
          if(!this.isBasket) {
            this.isAddressValid = this.validateAddress(newVal);
          }
        }
    },
    mounted () {

      if(!this.isBasket) {
        this.isAddressValid = this.validateAddress(this.billingAddress);
      }
     
    },
    methods:
    {
        changeStep(newStep)
        {
          if(this.isBasket && newStep != 1) {
              location.assign(`/${App.language}/checkout`);
          } else {
              if(!this.isBasket && newStep === 1) {
                location.assign(`/${App.language}/basket`);
              } else if (newStep < 4) {
                this.activeStep = newStep;
              } else {
                this.activeStep = 4;
                //reloadPayPalPlusWall();
              }
          }
        },
        nextStep()
        {
          if(this.spcount == 1 && this.activeStep == 2){
            this.changeStep(this.activeStep + 2); // Skip Step 3 if only 1
          }
          else{
            this.changeStep(this.activeStep + 1);
          }
          // this.changeStep(this.activeStep + 1);
        },
        validateAddress(address) {
            if(address && address.address1 && address.address2 && address.name2 && address.name3 && address.postalCode && address.town) {
              for (const options of address.options) {
                if(options && options.typeId === 5 && options.value) {
                  return true;
                }
              }
            }
            return false;
        }
    }
}
</script>
